import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { Component } from '@angular/core';
import { UiRouterResolverFactory } from '@client/app/shared/ui-router/ui-router-resolver-factory';
import { PageFixSummaryComponent } from '@client/app/modules/page-fix/pages/summary/summary.component';
import { PageFixListComponent } from '@client/app/modules/page-fix/pages/list/list.component';
import { PageFixChecksComponent } from '@client/app/modules/page-fix/pages/checks/checks.component';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { SessionService } from '@monsido/core/session/session.service';
import { StateService, Transition } from '@uirouter/core';
import { PAGE_CORRECT_DOMAIN_SETTINGS_MODULE } from '@client/ng2/modules/page-fix/constants/domain-settings-modules.constant';
import { MonUIRouterTransitionService } from '@monsido/services/ui-router-transition-service/ui-router-transition-service';

@Component({
    selector: 'base-page-fix',
    template: `<ui-view name="content"></ui-view>`,
    standalone: true,
    imports: [UIRouterModule],
})
class BasePageFixComponent {}

// Resolver functions
const hasAccessibilityAccess = [
    ActiveFeatureService,
    StateService,
    Transition,
    SessionService,
    MonUIRouterTransitionService,
    (
        activeFeatureService: ActiveFeatureService,
        stateService: StateService,
        transition: Transition,
        sessionService: SessionService,
        monUIRouterTransitionService: MonUIRouterTransitionService,
    ) => {
        if (activeFeatureService.isFeatureActive('accessibility')) {
            const domain = sessionService.domain;
            if (domain && domain.settings && domain.settings.scripts && domain.settings.scripts.page_correct) {
                const checks = domain.settings.scripts.page_correct.enabled_checks;
                if (checks.indexOf(PAGE_CORRECT_DOMAIN_SETTINGS_MODULE.ACCESSIBILITY_CHECK) > -1) {
                    return Promise.resolve(true);
                }
            }
        }
        return monUIRouterTransitionService.onTransitionFinished(() => {
            stateService.go('base.customer.domain.page-fix.summary', transition.params());
        });
    },
];

export const PAGE_FIX_STATES: Ng2StateDeclaration[] = [
    {
        name: 'base.customer.domain.page-fix',
        url: '/page-correct',
        abstract: true,
        views: {
            'content@base.customer.domain': {
                component: BasePageFixComponent,
            },
        },
        data: {
            features: ['page_fix'],
            sidebar: 'compliance-shield',
            title: 'Acquia Web Governance - PageCorrect summary',
        },
        resolve: UiRouterResolverFactory.createActiveFeatureStateResolver({
            token: 'hasPageFixAccess',
            features: ['page_fix'],
        }),
    },
    {
        name: 'base.customer.domain.page-fix.summary',
        url: '',
        views: {
            'content@base.customer.domain.page-fix': {
                component: PageFixSummaryComponent,
            },
        },
        data: { title: 'Acquia Web Governance - PageCorrect summary' },
    },
    {
        name: 'base.customer.domain.page-fix.index',
        url: '/list?page&page_size&tab&search',
        views: {
            'content@base.customer.domain.page-fix': {
                component: PageFixListComponent,
            },
        },
        data: { title: 'Acquia Web Governance - PageCorrect list of fixes' },
    },
    {
        name: 'base.customer.domain.page-fix.checks',
        url: '/checks?search',
        views: {
            'content@base.customer.domain.page-fix': {
                component: PageFixChecksComponent,
            },
        },
        data: { title: 'Acquia Web Governance - PageCorrect accessibility fixes' },
        resolve: {
            hasAccessibilityAccess: hasAccessibilityAccess,
        },
    },
];
